module.exports = __webpack_public_path__ + "static/media/netherlands.3b52ac76.png";